export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";